<template>
    <div id="login">

	<section class="loginMain">
		<div class="float-none height-100 position-relative">
			<!-- Partie entière gauche de la page-->
			<div class="d-flex fixed-top height-25 position-absolute position-topRight width-100 zone-top ">
				<!-- Visible uniquement en mode desktop : (d-none d-xl-block) -->
				<div class="d-none d-xl-block width-70 zone-topLeft">

				</div>
				
			</div>
			<!-- Partie entière droite de la page (30% de la largeur total )-->
			<div class="height-100 position-absolute position-topRight width-30">
				<!-- Partie étroite haute à droite de la page (30% de la largeur et 25% de la hauteur ) - LOGO-->
				<div class="height-25 d-flex justify-content-center flex-row-reverse flex-wrap overflow-hidden">
					
				</div>
				<!-- Partie large basse à droite de la page (30% de la largeur et 75% de la hauteur ) - FORMULAIRE -->
				<div class="height-75 d-flex justify-content-center flex-row flex-wrap overflow-hidden justify-content-center align-items-lg-start align-items-sm-center align-items-md-center align-items-lg-center" >

				</div>
			</div>
			<!-- Partie entière gauche de la page (70% de la largeur total et 100% de la hauteur ) - IMAGE -->
			<!-- Visible uniquement en mode desktop : (d-none d-xl-block) -->
			<div class="height-100 position-absolute position-topLeft loginImage d-none d-xl-block width-70" >
				<div class="py-2">

					
				</div>
			</div>
			<!-- Partie entière basse de la page (100% de la largeur total et 70% de la hauteur ) - IMAGE -->
			<div class="height-75 d-flex flex-row flex-wrap overflow-visible justify-content-center align-items-center zone-main">
				<div class="p-xs-1 p-sm-1 p-md-2 p-xl-1 loginCard d-flex justify-content-center flex-row flex-wrap overflow-auto align-items-center ">
					<div class="leftSide d-flex justify-content-center">
						<div class="p-md-2 mx-md-0 w-100 d-flex justify-content-start flex-column align-items-center">
							<div class="d-flex mb-2 h-100 w-100">
								<div class="d-flex justify-content-start flex-row flex-wrap w-100">
									<div class="w-100">
										<div class="brand_logo_container">
											<div class="brand_logo"></div>
										</div>
									</div>

									<div class="p-md-2 mx-md-3 mt-0 loginForm">
										<form>
											<div class="form-outline mb-4">
												<label class="form-label" for="username">{{ $t('log_User') }}</label>
												<b-form-input id="username" name="username" autocomplete="off" type="text" class="form-control input_user" :placeholder="$t('log_User')" v-model="txtUser"></b-form-input>
											</div>

											<div class="form-outline mb-0">
												<label class="form-label" for="password">{{ $t('log_Pass') }}</label>
												<b-form-input id="password" name="password" autocomplete="off" type="password" class="form-control input_pass" :placeholder="$t('log_Pass')" v-model="txtPass"></b-form-input>
											</div>

											<div class="d-flex flex-row mb-4">
												<div class="px-0"><a href="#!">{{$t('log_PassOublier')}}</a></div>
											</div>

											<div class="d-flex justify-content-between mb-2">
												<div class="d-flex flex-row flex-wrap">
													<div class="pt-2 mr-2"><span class="lienColor cursorPoint" @click="changeLang('en')">En</span></div>
													<div class="pt-2 ml-2"><span class="lienColor cursorPoint" @click="changeLang('fr')">Fr</span></div>
												</div>
											</div>

											<div class="text-center pt-1 mb-5 pb-1">
												<button type="button" name="button" class="px-5 btn login_btn" @click.prevent="handleLogin()">{{$t('log_Entrer')}}</button>
											</div>
										</form>
									</div>
								</div>
							</div>
							<!-- <div class="brand_logo_container">
								<div class="brand_logo"></div>
							</div> -->

							<!-- <div class="p-md-2 mx-md-3 mt-4 loginForm" style="border:1px solid red;">
								<form>
									<div class="form-outline mb-4">
										<label class="form-label" for="username">{{ $t('log_User') }}</label>
										<b-form-input id="username" name="username" autocomplete="off" type="text" class="form-control input_user" :placeholder="$t('log_User')" v-model="txtUser"></b-form-input>
									</div>

									<div class="form-outline mb-0">
										<label class="form-label" for="password">{{ $t('log_Pass') }}</label>
										<b-form-input id="password" name="password" autocomplete="off" type="password" class="form-control input_pass" :placeholder="$t('log_Pass')" v-model="txtPass"></b-form-input>
									</div>

									<div class="d-flex flex-row mb-4">
										<div class="px-0"><a href="#!">{{$t('log_PassOublier')}}</a></div>
									</div>

									<div class="d-flex justify-content-between mb-2">
										<div class="d-flex flex-row flex-wrap">
											<div class="pt-2 mr-2"><span class="lienColor cursorPoint" @click="changeLang('en')">En</span></div>
											<div class="pt-2 ml-2"><span class="lienColor cursorPoint" @click="changeLang('fr')">Fr</span></div>
										</div>
									</div>

									<div class="text-center pt-1 mb-5 pb-1">
										<button type="button" name="button" class="px-5 btn login_btn" @click.prevent="handleLogin()">{{$t('log_Entrer')}}</button>
									</div>
								</form>
							</div> -->
						</div>
					</div>
					<!-- Visible uniquement en mode desktop : (d-none d-xl-block) -->
					<div class="rightSide d-none d-xl-block ">
					</div>
				</div>
			</div>
		</div>
	</section> 

    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from 'axios';
import {dataService,userService} from '@/services'
export default{
    name: "login4",
    data() {
        return{
			Essais: false,
            posts: [],
            errors: null,
            user: null,
            txtUser: 'mp@omni-c.ca',
			txtPass: '',
			licence: 0,
        }
    },
    methods: {
		async fetchData() {
			await dataService.fetchData()
		},
		async handleLogin() {
			try {

				let url = this.$store.getters.getApiAdress + this.$store.getters.getApiAdd.portail.apiUser + '?user=' + this.txtUser + '&pass=' + this.txtPass;
                //let headers = {headers: {'Authorization': `Basic ${this.$CKey()}`}}

				const data =  await axios.get(url).then(response => { return response.data});

				userService.login(data, this.$i18n.locale)

				//this.$router.push({name: 'clientAccount' })
				this.$router.push({name: 'loading' })

				//await this.fetchData()
				
				/*
				let url =  "http://192.168.30.119:8081/api/v1/login2?user=mp%40omni-c.ca&pass=4";
				const data =  await axios.get(url).then(response => { return response.data}).catch(error => console.log(error));
				userService.login(data, this.$i18n.locale)
				this.$router.push({name: 'loading' })
				*/
				
			} catch (error) {
				console.log(error);
				alert("problems?");
			}
		},
        changeLang(lng){
            this.$i18n.locale = lng
			this.$store.commit('changeLanguage', this.$i18n.locale)
        },
    },
    computed: {
        ...mapGetters(['getApiAdress', 'getApiAdd', 'getworkLicence', 'getApiKey', 'getActiveTaxes', 'getToken', 'getUserId','isAuthenticated']),
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/views/login4.scss'
</style>